import { render, staticRenderFns } from "./SearchTax.vue?vue&type=template&id=ac0f8db2&scoped=true&"
import script from "./SearchTax.vue?vue&type=script&lang=js&"
export * from "./SearchTax.vue?vue&type=script&lang=js&"
import style0 from "./SearchTax.vue?vue&type=style&index=0&id=ac0f8db2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0f8db2",
  null
  
)

export default component.exports